export const visitDaysOptions = [
  { label: "Monday", value: "Monday" },
  { label: "Tuesday", value: "Tuesday" },
  { label: "Wednesday", value: "Wednesday" },
  { label: "Thursday", value: "Thursday" },
  { label: "Friday", value: "Friday" },
  { label: "Saturday", value: "Saturday" },
  { label: "Sunday", value: "Sunday" },
];

export const monthsData = [
  { id: 1, label: "January", value: "January" },
  { id: 2, label: "February", value: "February" },
  { id: 3, label: "March", value: "March" },
  { id: 4, label: "April", value: "April" },
  { id: 5, label: "May", value: "May" },
  { id: 6, label: "June", value: "June" },
  { id: 7, label: "July", value: "July" },
  { id: 8, label: "August", value: "August" },
  { id: 9, label: "September", value: "September" },
  { id: 10, label: "October", value: "October" },
  { id: 11, label: "November", value: "November" },
  { id: 12, label: "December", value: "December" },
];

export const yearData = [
  { id: 1, label: "2025", value: "2025" },
  { id: 2, label: "2026", value: "2026" },
  { id: 3, label: "2027", value: "2027" },
  { id: 4, label: "2028", value: "2028" },
  { id: 5, label: "2029", value: "2029" },
  { id: 6, label: "2030", value: "2030" },
];

export const genderOptions = [
  { label: "Male", value: "Male" },
  { label: "Female", value: "Female" },
  { label: "All", value: "All" },
];

export const jobTimeTypeOptions = [
  { label: "Monthly", value: "Monthly" },
  { label: "Fortnightly", value: "Fortnightly" },
];

export const stateOptions = [
  { label: "Victoria", value: "victoria" },
  { label: "Western Australia", value: "western_australia" },
  { label: "South Australia", value: "south_australia" },
  { label: "Queensland", value: "queensland" },
  { label: "Australian Capital Territory", value: "act" },
  { label: "New South Wales", value: "nsw" },
  { label: "Tasmania", value: "tasmania" },
  { label: "Northern Territory", value: "northern_territory" },
];

// Filter options for the main filter dropdown
export const filterOptions = [
  { label: "Active", value: "active" },
  { label: "Approve", value: "approve" },
  { label: "Deactivated", value: "deActivated" },
  { label: "Inactive", value: "inActive" },
];

export const kmOptions = [
  { label: "10 km", value: 10 },
  { label: "25 km", value: 25 },
  { label: "50 km", value: 50 },
  { label: "150 km", value: 150 },
];

// Status options for the individual row dropdown
export const statusOptions = [
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inActive" },
  { label: "Deactive", value: "deActivated" },
  // { label: 'Dormant', value: 'dormant' }
];
